import request from '@/modules/base/util/request'
import config from 'config'

const baseUrl = `${config.resourceHost}`

export const HubspotService = {
  getProperty: (objectType, property) => {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}hubspot/propertys/${objectType}/${property}`
      return request(url, { auth: true, isConcurrent: true, method: 'GET' })
        .then(response => {
          const { body: { data: { values } } } = response
          resolve(values)
        })
        .catch(error => reject(error))
    })
  },

}
